<mat-form-field [appearance]="appearance!">
  <mat-icon matPrefix *ngIf="icon">
    {{ icon }}
  </mat-icon>
  <mat-label>{{ label }}</mat-label>
  <input type="time" matInput [formControlName]="name">
</mat-form-field>